import styled from 'styled-components';

export const StyledCreditAppSummary = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background-color: ${({ theme }) => theme.tokens.BaseColorGray50};
`;

export const SummaryCard = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    width: 100%;
    padding: 2.5rem;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`;

export const SummaryHeader = styled.div`
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 2px solid #e9ecef;

    h1 {
        font-size: 1.75rem;
        font-weight: 600;
        color: #1d1e1f;
        margin: 1rem 0 0.5rem 0;

        @media (max-width: 768px) {
            font-size: 1.5rem;
        }
    }

    p {
        font-size: 1rem;
        color: #666;
        margin: 0;
    }
`;

export const SuccessIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;

    svg {
        animation: scaleIn 0.3s ease-out;
    }

    @keyframes scaleIn {
        from {
            transform: scale(0);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }
`;

export const SummaryBody = styled.div`
    h2 {
        font-size: 1.25rem;
        font-weight: 600;
        color: #1d1e1f;
        margin: 0 0 1.5rem 0;
    }
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }
`;

export const Label = styled.span`
    font-size: 0.9375rem;
    font-weight: 500;
    color: #666;
`;

export const Value = styled.span`
    font-size: 1rem;
    font-weight: 600;
    color: #1d1e1f;
    text-align: right;

    @media (max-width: 768px) {
        text-align: left;
    }
`;
